module.exports = "https://cdn.dashboard.gifty.nl/5978/images/emoti-5.png?ca6f6a3be4cd7e37666c8e3de438c7df";